/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S1_TitleInputs */

const en_guide_json_vs_yaml_xml_s1_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Comparison`)
};

const ko_guide_json_vs_yaml_xml_s1_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`간단 비교`)
};

const ja_guide_json_vs_yaml_xml_s1_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイック比較`)
};

/**
* | output |
* | --- |
* | "Quick Comparison" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S1_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s1_title = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S1_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S1_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s1_title(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s1_title(inputs)
	return ja_guide_json_vs_yaml_xml_s1_title(inputs)
});